import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "classes", "overrides", "error", "isFullWidth", "isReadOnly", "onChange", "value", "minLines", "maxLines"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AceEditor from 'react-ace';
import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-min-noconflict/ext-searchbox';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-markdown';
import 'ace-builds/src-noconflict/snippets/javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import { useClasses } from '../../../utils/overrides';
import InputWrapper from '../components/InputWrapper';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'Code');
var Code = /*#__PURE__*/memo(function (_ref) {
  var _classnames;
  var classNameProp = _ref.className,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    error = _ref.error,
    isFullWidth = _ref.isFullWidth,
    isReadOnly = _ref.isReadOnly,
    onChange = _ref.onChange,
    value = _ref.value,
    minLines = _ref.minLines,
    maxLines = _ref.maxLines,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  var rootClassName = classnames(classes.root, (_classnames = {}, _defineProperty(_classnames, classes.error, error), _defineProperty(_classnames, classes.isFullWidth, isFullWidth), _defineProperty(_classnames, classes.isReadOnly, isReadOnly), _classnames), classNameProp);
  return /*#__PURE__*/React.createElement(InputWrapper, _extends({}, props, {
    error: error,
    className: rootClassName,
    overrides: overridesProp,
    isFullWidth: isFullWidth,
    isReadOnly: isReadOnly
  }), /*#__PURE__*/React.createElement(AceEditor, _extends({
    value: value,
    onChange: onChange,
    readOnly: isReadOnly,
    width: "100%",
    mode: "javascript",
    theme: "monokai",
    showPrintMargin: false,
    showGutter: true,
    wrapEnabled: true,
    minLines: minLines,
    maxLines: maxLines,
    enableBasicAutocompletion: true,
    enableLiveAutocompletion: true,
    enableSnippets: true,
    showLineNumbers: true,
    tabSize: 2,
    editorProps: {
      $blockScrolling: Infinity
    }
  }, overridesProp.AceEditor)));
});
Code.overrides = ['AceEditor'];
Code.defaultProps = _objectSpread(_objectSpread({}, InputWrapper.defaultProps), {}, {
  isFullWidth: false,
  isReadOnly: false,
  onChange: function onChange() {},
  value: '',
  minLines: 20,
  maxLines: Infinity
});
process.env.NODE_ENV !== "production" ? Code.propTypes = {
  className: PropTypes.string,
  isFullWidth: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  minLines: PropTypes.number,
  maxLines: PropTypes.number
} : void 0;
export default Code;